export const getCheckoutValidationMessages = (
  validationMessages,
  fallbackMessage
) => {
  if (!validationMessages || typeof validationMessages !== "object") {
    return [];
  }

  return Object.entries(validationMessages).map(([field, value]) => {
    if (Array.isArray(value) && value.length > 0) {
      return {
        field,
        message: String(value[0] || fallbackMessage),
      };
    }

    if (typeof value === "string" && value.trim()) {
      return {
        field,
        message: value,
      };
    }

    return {
      field,
      message: fallbackMessage,
    };
  });
};
